import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "titlePages" }
const _hoisted_2 = { class: "mapa-wrapper" }
const _hoisted_3 = { class: "controles-custom-top-left" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  id: "mapClients",
  class: "mapClients"
}, null, -1)
const _hoisted_5 = { class: "ml-2 mt-0 legendMapDash" }
const _hoisted_6 = { class: "text-green-accent-3 font-weight-bold" }
const _hoisted_7 = { class: "text-caption text-grey-lighten-1" }
const _hoisted_8 = { class: "d-flex justify-space-between text-body-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "text-grey" }, "Temperatura:", -1)
const _hoisted_10 = { class: "d-flex justify-space-between text-body-2" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "text-grey" }, "Voltaje Sensor In:", -1)
const _hoisted_12 = { class: "d-flex justify-space-between text-body-2" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "text-grey" }, "Noise:", -1)

import { watch, ref, onMounted, computed } from "vue";

/********************************
 ************ STORE *************
 *******************************/
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import { useDisplay } from "vuetify";
import maplibregl, { LngLatLike } from "maplibre-gl";
import "maplibre-gl/dist/maplibre-gl.css";

/********************************
 ********** CONSTANTES **********
 *******************************/
import CONSTMAPS from "@/constants/maps";
import { LABELS } from "@/constants/labels";

/********************************
 *********** SERVICES ***********
 *******************************/
import {
  getAllDriveClientsDevices,
  getRajantGPS,
} from "@/services/Smartlink/Drive";


/**
 * Título de la vista
 */
import { getAllHexagonTemperature, getDataTemperaturePredictLastMinute } from "../../../services/Smartlink/Map";
import { COLOR } from "@/constants/colors";

import rangeComponent from "@/components/SmartLink/dashboard/rangeComponent.vue";

import iconoSolarTrailer from "@/assets/Icons/solartrailer3.jpg";
import iconoPala from "@/assets/Icons/pala.jpg";
import iconoPerforadora from "@/assets/Icons/perforadora.jpg";
import iconoCamion from "@/assets/Icons/camion.jpg";
import iconoCargadorFrontal from "@/assets/Icons/cargadorfrontal.jpg"
import iconoPipaAgua from "@/assets/Icons/pipadeagua.jpg"
import { ICON_IMGS } from "@/constants/drive";

interface EquipoJerarquia {
    ip: string;
    tag: string;
    macs: string[];
}

// --- ESTADO REACTIVO ---
interface Equipo {
  fecha: string;
  latitud: number;
  longitud: number;
  marca: string;
  name: string;
  noise: number;
  subtipo: string;
  temperatura: number;
  tipo: string;
  voltaje: number;
}



export default /*#__PURE__*/_defineComponent({
  __name: 'DriveClientsView',
  setup(__props) {

const store = useStore();

/********************************
 ************ I18N **************
 *******************************/
const { t } = useI18n();

/********************************
 ************ VUETIFY ***********
 *******************************/
const { smAndDown } = useDisplay();

/********************************
 *********** MAPLIBRE ***********
 *******************************/
const title = ref("Mina Visual");

const selectedEquiposCliente = ref<string[]>([]);
const selectedMacs = ref<string[]>([]);
const showAllClients = ref(false);
const openedGroups = ref([]);
const jerarquiaEquipos = ref<any[]>([]);

/**
 * 1. PROCESAMIENTO DE JERARQUÍA (4 NIVELES)
 */
const inicializarJerarquia = async (data: any[]) => {
    const tree = new Map();

    data.forEach(equipo => {
        const subtipo = equipo.rol || "Acceso";
        const tipo = equipo.tipo || "General";

        if (!tree.has(subtipo)) tree.set(subtipo, new Map());
        const subtipoMap = tree.get(subtipo);

        if (!subtipoMap.has(tipo)) subtipoMap.set(tipo, []);

        // Procesar MACs desde el campo wireless
        const wireless = typeof equipo.wireless === 'string' ? JSON.parse(equipo.wireless) : equipo.wireless;
        const listaMacs: string[] = [];
        if (wireless) {
            Object.values(wireless).forEach((wlan: any) => {
                wlan.clients?.forEach((c: any) => listaMacs.push(c.mac));
            });
        }

        subtipoMap.get(tipo).push({
            ip: equipo.ip,
            tag: equipo.name || equipo.ip,
            macs: listaMacs
        });
    });

    jerarquiaEquipos.value = Array.from(tree).map(([nombreSubtipo, tiposMap]) => ({
        nombre: nombreSubtipo,
        tipos: Array.from(tiposMap as Map<string, EquipoJerarquia[]>).map(([nombreTipo, equipos]) => ({
            nombre: nombreTipo,
            equipos: equipos
        }))
    }));

};

/**
 * 2. FUNCIONES DE CONTROL (CHECKBOXES)
 */

// Nivel 1: Subtipo
const toggleSubtipoCliente = (subtipo: any) => {
    const equipos = subtipo.tipos.flatMap((t: any) => t.equipos);
    const ips = equipos.map((e: any) => e.ip);
    const macsCompuestas = equipos.flatMap((e: any) => e.macs.map((m: string) => `${e.ip}-${m}`));

    const allSelected = ips.every((ip: string) => selectedEquiposCliente.value.includes(ip));

    if (allSelected) {
        selectedEquiposCliente.value = selectedEquiposCliente.value.filter(ip => !ips.includes(ip));
        selectedMacs.value = selectedMacs.value.filter(m => !macsCompuestas.includes(m));
    } else {
        selectedEquiposCliente.value = [...new Set([...selectedEquiposCliente.value, ...ips])];
        selectedMacs.value = [...new Set([...selectedMacs.value, ...macsCompuestas])];
    }
};

// Nivel 2: Tipo
const toggleTipoCliente = (tipo: any) => {
    const ips = tipo.equipos.map((e: any) => e.ip);
    const macsCompuestas = tipo.equipos.flatMap((e: any) => e.macs.map((m: string) => `${e.ip}-${m}`));

    const allSelected = ips.every((ip: string) => selectedEquiposCliente.value.includes(ip));

    if (allSelected) {
        selectedEquiposCliente.value = selectedEquiposCliente.value.filter((ip: string) => !ips.includes(ip));
        selectedMacs.value = selectedMacs.value.filter((m: string) => !macsCompuestas.includes(m));
    } else {
        selectedEquiposCliente.value = [...new Set([...selectedEquiposCliente.value, ...ips])];
        selectedMacs.value = [...new Set([...selectedMacs.value, ...macsCompuestas])];
    }
};

// Nivel 3: Equipo (IP)
const toggleEquipo = (equipo: any) => {
    const ip = equipo.ip;
    const macsCompuestas = equipo.macs.map((m: string) => `${ip}-${m}`);

    if (selectedEquiposCliente.value.includes(ip)) {
        selectedEquiposCliente.value = selectedEquiposCliente.value.filter(i => i !== ip);
        selectedMacs.value = selectedMacs.value.filter(m => !macsCompuestas.includes(m));
    } else {
        selectedEquiposCliente.value.push(ip);
        selectedMacs.value = [...new Set([...selectedMacs.value, ...macsCompuestas])];
    }
};

// Switch Maestro
const toggleAllClients = (value: boolean | null) => {
    if (value) {
        const ips = allRajantArray.value.map((e: any) => e.ip);
        const macs: string[] = [];
        allRajantArray.value.forEach((e: any) => {
            const wireless = typeof e.wireless === 'string' ? JSON.parse(e.wireless) : e.wireless;
            Object.values(wireless || {}).forEach((wlan: any) => {
                wlan.clients?.forEach((c: any) => macs.push(`${e.ip}-${c.mac}`));
            });
        });
        selectedEquiposCliente.value = ips;
        selectedMacs.value = macs;
    } else {
        selectedEquiposCliente.value = [];
        selectedMacs.value = [];
    }
};

watch(showAllClients, (val) => {
    if (val) {
        toggleAllClients(true);
    } else {
        toggleAllClients(false);
    }
});
/**
 * 3. CHECKERS DE ESTADO
 */
const isSubtipoSelectedCliente = (subtipo: any) => 
    subtipo.tipos.flatMap((t: any) => t.equipos).every((e: any) => selectedEquiposCliente.value.includes(e.ip));

const isTipoSelectedCliente = (tipo: any) => 
    tipo.equipos.every((e: any) => selectedEquiposCliente.value.includes(e.ip));

/**
 * 4. WATCHER PARA EL MAPA
 */
watch([selectedEquiposCliente, selectedMacs], () => {
    if (!mapClients || !mapClients.getLayer("layer-equipos-icono")) return;

    const filterEquipos = selectedEquiposCliente.value.length > 0
        ? ["in", ["get", "id"], ["literal", selectedEquiposCliente.value]]
        : ["==", ["get", "id"], "none"];

    const filterFinal = selectedMacs.value.length > 0
        ? ["in", ["get", "id"], ["literal", selectedMacs.value]]
        : ["==", ["get", "id"], "none"];

    mapClients.setFilter("layer-equipos-icono", filterEquipos);
    mapClients.setFilter("layer-clientes-macs", filterFinal);
    mapClients.setFilter("layer-enlaces", filterFinal);
}, { deep: true });

function processDataToGeoJSON(dataArray: any[]) {
  const points: any = { type: "FeatureCollection", features: [] };
  const lines: any = { type: "FeatureCollection", features: [] };

  dataArray.forEach((equipo) => {
    // Equipo principal
    points.features.push({
      type: "Feature",
      properties: {
        id: equipo.ip,
        type: "equipo",
        parentId: equipo.ip,
        name: equipo.name,
      },
      geometry: {
        type: "Point",
        coordinates: [equipo.longitud, equipo.latitud],
      },
    });

    const wireless =
      typeof equipo.wireless === "string"
        ? JSON.parse(equipo.wireless)
        : equipo.wireless;

    Object.values(wireless).forEach((wlan: any) => {
      if (wlan.clients) {
        wlan.clients.forEach((client: any) => {
          // Dispersión de clientes para que no queden uno encima de otro
          const cLng = equipo.longitud + (Math.random() - 0.5) * 0.005;
          const cLat = equipo.latitud + (Math.random() - 0.5) * 0.005;

          // --- CLAVE: ID ÚNICO COMPUESTO ---
          const uniqueId = `${equipo.ip}-${client.mac}`;

          if(client.signal !== undefined && client.signal !== 0){
            points.features.push({
              type: "Feature",
              properties: {
                id: uniqueId,
                type: "cliente",
                parentId: equipo.ip,
                mac: client.mac,
                signal: client.signal ?? 0,
              },
              geometry: { type: "Point", coordinates: [cLng, cLat] },
            });

            lines.features.push({
              type: "Feature",
              properties: { id: uniqueId, parentId: equipo.ip, mac: client.mac },
              geometry: {
                type: "LineString",
                coordinates: [
                  [equipo.longitud, equipo.latitud],
                  [cLng, cLat],
                ],
              },
            });
          // }
          }

          
        });
      }
    });
  });
  return { points, lines };
}

/**
 * Obtener las posiciones de los equipos Rajant
 */
async function getRajantPositions() {
  await getDriveClientsDevices();
  await getALLRajantGPS();

  await inicializarJerarquia(allRajantArray.value)


  // 1. Generar los GeoJSON con la función que definimos antes
  const data = processDataToGeoJSON(allRajantArray.value);

  // 2. Añadir Sources
  mapClients.addSource("src-puntos", { type: "geojson", data: data.points });
  mapClients.addSource("src-enlaces", { type: "geojson", data: data.lines });

  // 3. Añadir Capas

  // Capa de Líneas (Enlaces)
  mapClients.addLayer({
    id: "layer-enlaces",
    type: "line",
    source: "src-enlaces",
    layout: {
      'visibility': 'none'
    },
    paint: {
      "line-color": "#00FFFF",
      "line-width": 2,
      "line-dasharray": [2, 1], // Línea punteada para los enlaces
    },
  });

  // Capa de Equipos (Tu Icono)
  mapClients.addLayer({
    id: "layer-equipos-icono",
    type: "symbol",
    source: "src-puntos",
    filter: ["==", ["get", "type"], "equipo"],
    layout: {
      "visibility": "none",
      "icon-image": "iconoSolarTrailer",
      "text-allow-overlap": true,
      "icon-size": 0.9,
      "icon-allow-overlap": true,
      "text-field": ["get", "name"],
      "text-size": 12,
      "text-offset": [0, 2],
      "text-anchor": "top",
    },
    paint: {
      "text-color": "#FFFFFF",
      "text-halo-color": "#000000",
      "text-halo-width": 2.0,
    },
  });

  mapClients.addLayer({
    id: "layer-clientes-macs",
    type: "symbol",
    source: "src-puntos",
    filter: ["==", ["get", "type"], "cliente"], // Solo clientes
    layout: {
      "visibility": "none",
      // Obtenemos la propiedad 'mac' + ' (signal dBm)' que guardamos en processDataToGeoJSON
      "text-field": [
        "concat",
        ["get", "mac"],
        " (",
        ["get", "signal"],
        " dBm)",
      ],
      "text-size": 14,
      "text-offset": [0, 0], // Centrado dentro o sobre el círculo
      "text-allow-overlap": true, // No permitir que se pisen entre ellos
      "text-ignore-placement": true,
    },
    paint: {
      "text-color": "#66BB6A", // Texto blanco
      "text-halo-color": "#000000", // Halo negro para legibilidad sobre cualquier mapa
      "text-halo-width": 2.0,
    },
  });
}


/**
 * Lista de los Equipos Rajant con toda su información (Ancho de Banda y GPS)
 */
const allRajantArray = ref<any>([]);

/**
 * Obtener todas las coordenadas GPS de los equipos Rajant
 */
async function getALLRajantGPS() {
  const allData = await getRajantGPS();

  if (allData.status === 400) {
    store.commit("showSnackBar", {
      type: LABELS.error,
      msg: t("snackbar.errorApis"),
      valor: true,
    });
  }
  if (allData.status === 200) {
    allRajantArray.value.forEach((item: any) => {
      allData.data.find(({ ip, latitud, longitud }: any) => {
        if (ip === item.ip) {
          item.latitud = latitud;
          item.longitud = longitud;
        }
      });
    });
  }
}

/**
 * Obtener el Ancho de Banda de todos los equipos Rajant
 */
async function getDriveClientsDevices() {
  const allData = await getAllDriveClientsDevices();

  if (allData.status === 400) {
    store.commit("showSnackBar", {
      type: LABELS.error,
      msg: t("snackbar.errorApis"),
      valor: true,
    });
  }
  if (allData.status === 200) {
    allRajantArray.value = allData.data;
  }
  // allRajantArray.value = DRIVECLIENTS
}

const showAllClustering = ref(true);

/*****************************************************
 ** HEXÁGONOS DE TEMPERATURA (CLUSTERING DE CALOR) **
 ***************************************************/

async function renderHexagons(map:any) {
  
  const allData:any = await getAllHexagonTemperature()

  if( allData.status === 400 ){
      store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
  }
  if( allData.status === 200 ){
    const geojsonData = allData.data

      // Si la fuente ya existe (por una actualización), actualizamos los datos
    if (map.getSource('hexagonos-clustering')) {
      map.getSource('hexagonos-clustering').setData(geojsonData);
    } else {
      map.addSource('hexagonos-clustering', {
        type: 'geojson',
        data: geojsonData
      });

      // 3. Añadir la Capa de Relleno (Fill)
      map.addLayer({
        id: 'layer-hexagonos-fill',
        type: 'fill',
        source: 'hexagonos-clustering',
        layout: { 
          'visibility': 'none' // <--- OCULTO POR DEFECTO
        },
        paint: {
          // Usamos la propiedad 'color' que ya viene en tu GeoJSON
          'fill-color': ['get', 'color'],
          'fill-opacity': 0.6
        }
      });

      // 4. Añadir una Capa de Línea (Bordes) para que se vea definido
      map.addLayer({
        id: 'layer-hexagonos-line',
        type: 'line',
        source: 'hexagonos-clustering',
        layout: { 
          'visibility': 'none' // <--- OCULTO POR DEFECTO
        },
        paint: {
          'line-color': '#ffffff',
          'line-width': 0.5,
          'line-opacity': 0.8
        }
      });

      // 5. Interactividad: Popup al hacer click
      map.on('click', 'layer-hexagonos-fill', (e: any) => {
        const props = e.features[0].properties;

        // Creamos el popup
        new maplibregl.Popup()
          .setLngLat(e.lngLat)
          .setHTML(`
            <div style="font-family: sans-serif; padding: 5px;">
              <strong style="display: block; font-size: 1.1em; margin-bottom: 5px;">
                Estado: <span style="color: ${props.color}">${props.estado}</span>
              </strong>
              <strong>Temp. Promedio:</strong> ${props.tempPromedio} °C<br>
              <strong>Muestras:</strong> ${props.muestras}
            </div>
          `)
          .addTo(map);
      });

      // Cambiar el cursor al pasar sobre un hexágono
      map.on('mouseenter', 'layer-hexagonos-fill', () => map.getCanvas().style.cursor = 'pointer');
      map.on('mouseleave', 'layer-hexagonos-fill', () => map.getCanvas().style.cursor = '');
    }
  
  }
}


watch(showAllClustering, (val) => {
  if (!mapClients) return; // Asegúrate de tener acceso a la instancia del mapa

  const visibility = val ? 'visible' : 'none';

  if (mapClients.getLayer('layer-hexagonos-fill')) {
    mapClients.setLayoutProperty('layer-hexagonos-fill', 'visibility', visibility);
  }
  if (mapClients.getLayer('layer-hexagonos-line')) {
    mapClients.setLayoutProperty('layer-hexagonos-line', 'visibility', visibility);
  }
});



/**********************************************************************
 ** OBTENER DATOS DE PREDICCIÓN DE TEMPERATURA PARA EL ÚLTIMO MINUTO **
 **********************************************************************/
const rawDataTemperatura = ref<Equipo[]>([]);
const selectedEquiposTemperatura = ref<string[]>([]);
const allVisibleTemperatura = ref(false);

const hoverData = ref({
  show: false,
  x: 0,
  y: 0,
  nombre: '',
  ip: '',
  temp: 0,
  volt: 0,
  noise: 0
});

const hierarchy = computed(() => {
  const tree: any = {};
  rawDataTemperatura.value.forEach(e => {
    if (!tree[e.subtipo]) tree[e.subtipo] = {};
    if (!tree[e.subtipo][e.tipo]) tree[e.subtipo][e.tipo] = [];
    tree[e.subtipo][e.tipo].push(e);
  });
  return tree;
});

// --- Filtros ---
const toggleAll = () => {
  selectedEquiposTemperatura.value = allVisibleTemperatura.value ? rawDataTemperatura.value.map(e => e.name) : [];
};

const toggleSubtipo = (subtipo: string) => {
  const equiposNames = Object.values(hierarchy.value[subtipo]).flat().map((e: any) => e.name);
  const allPresent = equiposNames.every(name => selectedEquiposTemperatura.value.includes(name));
  
  if (allPresent) {
    selectedEquiposTemperatura.value = selectedEquiposTemperatura.value.filter(n => !equiposNames.includes(n));
  } else {
    selectedEquiposTemperatura.value = [...new Set([...selectedEquiposTemperatura.value, ...equiposNames])];
  }
};

const isSubtipoSelected = (subtipo: string) => {
  const equiposNames = Object.values(hierarchy.value[subtipo]).flat().map((e: any) => e.name);
  return equiposNames.every(name => selectedEquiposTemperatura.value.includes(name));
};

const toggleTipo = (subtipo: string, tipo: string) => {
  const equiposNames = hierarchy.value[subtipo][tipo].map((e: any) => e.name);
  const allPresent = equiposNames.every((name:any) => selectedEquiposTemperatura.value.includes(name));
  
  if (allPresent) {
    selectedEquiposTemperatura.value = selectedEquiposTemperatura.value.filter(n => !equiposNames.includes(n));
  } else {
    selectedEquiposTemperatura.value = [...new Set([...selectedEquiposTemperatura.value, ...equiposNames])];
  }
};

const isTipoSelected = (subtipo: string, tipo: string) => {
  return hierarchy.value[subtipo][tipo].every((e: any) => selectedEquiposTemperatura.value.includes(e.name));
};

// --- Watcher para actualizar el mapa ---
watch(selectedEquiposTemperatura, (newVal) => {
  if (mapClients && mapClients.getLayer('equipos-layer')) {
    mapClients.setFilter('equipos-layer', ['in', ['get', 'name'], ['literal', newVal]]);
  }
}, { deep: true });

/**
 * Configura o actualiza la fuente de datos y la capa de equipos en el mapa.
 * @param map instancia de MapLibre
 * @param data array de equipos obtenidos de la API
 */
const setupMapLayers = (map: maplibregl.Map, data: Equipo[]) => {
  // 1. Transformar datos a GeoJSON
  const geojsonData: GeoJSON.FeatureCollection = {
    type: 'FeatureCollection',
    features: data.map(e => ({
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [e.longitud, e.latitud]
      },
      properties: { ...e, icono: ICON_IMGS[e.tipo.toLowerCase() ?? 'tractor'] } // Pasamos todas las props para el hover sheet
    }))
  };

  // 2. Manejo de la Fuente (Source)
  // Si ya existe, actualizamos los datos; si no, la creamos.
  if (map.getSource('equipos')) {
    (map.getSource('equipos') as maplibregl.GeoJSONSource).setData(geojsonData);
  } else {
    map.addSource('equipos', {
      type: 'geojson',
      data: geojsonData
    });
  }

  // 3. Manejo de la Capa (Layer)
  if (!map.getLayer('equipos-layer')) {
    map.addLayer({
      id: 'equipos-layer',
      type: 'symbol',
      source: 'equipos',
      filter: ['in', ['get', 'name'], ['literal', selectedEquiposTemperatura.value]],
      layout: {
        // Lógica de iconos según subtipo
        'icon-image': ['get', 'icono'],
        'icon-size': 1.0,
        'icon-allow-overlap': true,
        'text-allow-overlap': true,
        // Configuración del texto (Nombre)
        'text-field': ['get', 'name'],
        'text-font': ['Open Sans Bold', 'Arial Unicode MS Bold'],
        'text-size': 12,
        'text-offset': [0, 1.5],
        'text-anchor': 'top'
      },
      paint: {
        'text-color': '#ffffff',
        'text-halo-color': '#2E7D32', // Halo verde (Green darken-3)
        'text-halo-width': 2
      }
    });

    allVisibleTemperatura.value = false; // Desactivamos el switch global al cargar la capa por primera vez

    // 4. Lógica de Interacción (Hover)
    map.on('mousemove', 'equipos-layer', (e) => {
      // Cambiar cursor
      map.getCanvas().style.cursor = 'pointer';

      if (e.features && e.features.length > 0) {
        const props = e.features[0].properties;
        
        // Capturamos la posición del mouse en la pantalla
        // e.point.x y e.point.y son relativos al canvas del mapa
        hoverData.value = {
          show: true,
          x: e.point.x,
          y: e.point.y,
          nombre: props.name,
          ip: props.marca, // O el campo que corresponda a IP
          temp: props.temperatura,
          volt: props.voltaje,
          noise: props.noise
        };
      }
    });

    map.on('mouseleave', 'equipos-layer', () => {
      map.getCanvas().style.cursor = '';
      hoverData.value.show = false;
    });
  }
};

async function getDataTempePredictLastMinute(){
  const allData = await getDataTemperaturePredictLastMinute();

  if (allData.status === 400) {
    store.commit("showSnackBar", {
      type: LABELS.error,
      msg: t("snackbar.errorApis"),
      valor: true,
    });
  }
  if (allData.status === 200) {
   // 1. Guardamos en nuestra variable reactiva para el menú de filtros
    rawDataTemperatura.value = allData.data;
    
    // 2. Inicializamos los seleccionados (por defecto todos visibles)
    // selectedEquiposTemperatura.value = rawDataTemperatura.value.map(e => e.name);
    const equiposAcceso = allData.data.filter((e: Equipo) => 
      e.subtipo?.toLowerCase() === 'acceso' || e.tipo?.toLowerCase() === 'acceso'
    );
    
    // Asignamos solo los nombres de los equipos de Acceso para que se marquen en el mapa y en el árbol
    selectedEquiposTemperatura.value = equiposAcceso.map((e: Equipo) => e.name);

    // 3. LLAMADA A LA LÓGICA DEL MAPA
    // Asegúrate de que 'mapClients' sea accesible (variable global o ref)
    if (mapClients) {
      setupMapLayers(mapClients, allData.data);
    }
  }

}

// =================================================================
// --- LOGICA DE EXCLUSIÓN MUTUA TOTAL (WATCHERS DE SWITCHES) ---
// =================================================================

watch(showAllClients, (val) => {
  if (!mapClients) return;
  const visibility = val ? 'visible' : 'none';

  // 1. Controlar visibilidad de capas de Clientes en el mapa
  if (mapClients.getLayer('layer-equipos-icono')) mapClients.setLayoutProperty('layer-equipos-icono', 'visibility', visibility);
  if (mapClients.getLayer('layer-clientes-macs')) mapClients.setLayoutProperty('layer-clientes-macs', 'visibility', visibility);
  if (mapClients.getLayer('layer-enlaces')) mapClients.setLayoutProperty('layer-enlaces', 'visibility', visibility);

  // 2. Si se ACTIVA Clientes, se APAGA por completo todo lo de Temperatura e IA
  if (val) {    
    showAllClustering.value = false; 
    allVisibleTemperatura.value = false; 
    selectedEquiposTemperatura.value = []; // Desmarca todos los checkboxes de temperatura
  } else {
    // Si se desactiva manualmente el switch de Clientes, limpiamos sus selecciones
    selectedEquiposCliente.value = [];
    selectedMacs.value = [];
  }
});

watch(showAllClustering, (val) => {
  if (!mapClients) return;
  const visibility = val ? 'visible' : 'none';

  // 1. Controlar visibilidad de capas de Hexágonos (Clustering)
  if (mapClients.getLayer('layer-hexagonos-fill')) mapClients.setLayoutProperty('layer-hexagonos-fill', 'visibility', visibility);
  if (mapClients.getLayer('layer-hexagonos-line')) mapClients.setLayoutProperty('layer-hexagonos-line', 'visibility', visibility);

  // 2. Si se ACTIVA el Clustering, se APAGA todo lo de Clientes
  if (val) {    
    showAllClients.value = false; 
    // Nota: El watcher de 'showAllClients' se disparará automáticamente al ponerlo en false,
    // limpiando así los arreglos 'selectedEquiposCliente' y 'selectedMacs'.
  } 
});

watch(allVisibleTemperatura, (val) => {
  // Si se ACTIVA "Mostrar Todo" en Temperatura, se APAGA todo lo de Clientes
  if (val) {    
    showAllClients.value = false; 
  } 
});

// NUEVO: Watcher para cuando el usuario interactúa con los checkboxes individuales de Temperatura
watch(selectedEquiposTemperatura, (newVal) => {
  // Si el usuario selecciona manualmente algún equipo de temperatura en el árbol,
  // asumimos que quiere ver Temperatura y por ende apagamos la sección de Clientes
  if (newVal.length > 0) {
    showAllClients.value = false;
  }
}, { deep: true });



let mapClients: any = "";
const centerMap = ref<LngLatLike>([
  CONSTMAPS.longitud.value,
  CONSTMAPS.latitud.value,
]);

onMounted(async () => {
  mapClients = new maplibregl.Map({
    container: "mapClients",
    center: centerMap.value,
    zoom: 14,
    pitch: 40,
    bearing: 30,
    antialias: true,
    style:
      "https://api.maptiler.com/maps/satellite/style.json?key=6JWVt6LFaY22nquimZpF",
  });

  mapClients.addControl(new maplibregl.NavigationControl(), "top-right");
  mapClients.addControl(new maplibregl.FullscreenControl(), "top-right");

  const imgSolarTrailer = new Image(45, 45);

  imgSolarTrailer.onload = () => {
    mapClients.addImage("iconoSolarTrailer", imgSolarTrailer);
  };

  imgSolarTrailer.src = iconoSolarTrailer;

  const imgPala = new Image(45, 45);

  imgPala.onload = () => {
    mapClients.addImage("iconoPala", imgPala);
  };

  imgPala.src = iconoPala;

  const imgPerforadora = new Image(45, 45);

  imgPerforadora.onload = () => {
    mapClients.addImage("iconoPerforadora", imgPerforadora);
  };

  imgPerforadora.src = iconoPerforadora;

  const imgCamion = new Image(45, 45);

  imgCamion.onload = () => {
    mapClients.addImage("iconoCamion", imgCamion);
  };

  imgCamion.src = iconoCamion;

  const imgCargadorFrontal = new Image(45, 45);

  imgCargadorFrontal.onload = () => {
    mapClients.addImage("iconoCargadorFrontal", imgCargadorFrontal);
  };

  imgCargadorFrontal.src = iconoCargadorFrontal;

  const imgPipaAgua = new Image(45, 45);

  imgPipaAgua.onload = () => {
    mapClients.addImage("iconoPipaAgua", imgPipaAgua);
  };

  imgPipaAgua.src = iconoPipaAgua;


  mapClients.on("load", async () => {
    await renderHexagons(mapClients);
    await getRajantPositions();
    await getDataTempePredictLastMinute();

    mapClients.setLayoutProperty('layer-hexagonos-fill', 'visibility', 'visible');
    mapClients.setLayoutProperty('layer-hexagonos-line', 'visibility', 'visible');
  });
});

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_checkbox_btn = _resolveComponent("v-checkbox-btn")!
  const _component_v_list_group = _resolveComponent("v-list-group")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_sheet = _resolveComponent("v-sheet")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("span", _hoisted_1, _toDisplayString(title.value), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (allRajantArray.value.length > 0)
          ? (_openBlock(), _createBlock(_component_v_menu, {
              key: 0,
              "close-on-content-click": false,
              location: "bottom start"
            }, {
              activator: _withCtx(({ props }) => [
                _createVNode(_component_v_btn, _mergeProps({ color: "#84D98E" }, props, {
                  "prepend-icon": "mdi-truck",
                  elevation: "2"
                }), null, 16)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_v_card, {
                  "min-width": "400",
                  "max-height": "600",
                  class: "overflow-y-auto mt-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list, {
                      opened: openedGroups.value,
                      "onUpdate:opened": _cache[6] || (_cache[6] = ($event: any) => ((openedGroups).value = $event)),
                      density: "compact"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_group, { value: "seccion_clientes" }, {
                          activator: _withCtx(({ props }) => [
                            _createVNode(_component_v_list_item, _mergeProps(props, {
                              "prepend-icon": "mdi-dump-truck",
                              title: "CLIENTES"
                            }), null, 16)
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item, { class: "py-2" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_switch, {
                                  modelValue: showAllClients.value,
                                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showAllClients).value = $event)),
                                  label: "Mostrar Todo",
                                  color: "green",
                                  "hide-details": ""
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_divider, { class: "border-opacity-25 my-2" }),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(jerarquiaEquipos.value, (subtipo) => {
                              return (_openBlock(), _createBlock(_component_v_list_group, {
                                key: 'client-' + subtipo.nombre,
                                value: 'client-' + subtipo.nombre
                              }, {
                                activator: _withCtx(({ props }) => [
                                  _createVNode(_component_v_list_item, _normalizeProps(_guardReactiveProps(props)), {
                                    prepend: _withCtx(() => [
                                      _createVNode(_component_v_icon, {
                                        icon: "mdi-transit-connection-variant",
                                        color: "white",
                                        class: "mr-2"
                                      })
                                    ]),
                                    append: _withCtx(() => [
                                      _createVNode(_component_v_checkbox_btn, {
                                        "model-value": isSubtipoSelectedCliente(subtipo),
                                        onClick: _withModifiers(($event: any) => (toggleSubtipoCliente(subtipo)), ["stop"]),
                                        color: "green",
                                        "hide-details": ""
                                      }, null, 8, ["model-value", "onClick"])
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list_item_title, { class: "text-subtitle-1 font-weight-bold" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(subtipo.nombre), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1040)
                                ]),
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subtipo.tipos, (tipo) => {
                                    return (_openBlock(), _createBlock(_component_v_list_group, {
                                      key: 'client-tipo-' + subtipo.nombre + tipo.nombre,
                                      value: 'client-tipo-' + subtipo.nombre + tipo.nombre
                                    }, {
                                      activator: _withCtx(({ props }) => [
                                        _createVNode(_component_v_list_item, _mergeProps(props, {
                                          "bg-color": "#1e293b",
                                          class: "pl-6"
                                        }), {
                                          prepend: _withCtx(() => [
                                            _createVNode(_component_v_icon, {
                                              icon: "mdi-folder-outline",
                                              size: "small",
                                              class: "mr-n2"
                                            })
                                          ]),
                                          append: _withCtx(() => [
                                            _createVNode(_component_v_checkbox_btn, {
                                              "model-value": isTipoSelectedCliente(tipo),
                                              onClick: _withModifiers(($event: any) => (toggleTipoCliente(tipo)), ["stop"]),
                                              color: "green",
                                              "hide-details": ""
                                            }, null, 8, ["model-value", "onClick"])
                                          ]),
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_list_item_title, { class: "text-body-2" }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(tipo.nombre), 1)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1040)
                                      ]),
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tipo.equipos, (eq) => {
                                          return (_openBlock(), _createBlock(_component_v_list_group, {
                                            key: eq.ip,
                                            value: eq.ip
                                          }, {
                                            activator: _withCtx(({ props }) => [
                                              _createVNode(_component_v_list_item, _mergeProps(props, { class: "pl-10" }), {
                                                prepend: _withCtx(() => [
                                                  _createVNode(_component_v_checkbox_btn, {
                                                    "model-value": selectedEquiposCliente.value.includes(eq.ip),
                                                    onClick: _withModifiers(($event: any) => (toggleEquipo(eq)), ["stop"]),
                                                    color: "green",
                                                    "hide-details": ""
                                                  }, null, 8, ["model-value", "onClick"])
                                                ]),
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_list_item_title, { class: "text-caption font-weight-bold" }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(eq.tag), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1040)
                                            ]),
                                            default: _withCtx(() => [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(eq.macs, (mac) => {
                                                return (_openBlock(), _createBlock(_component_v_list_item, {
                                                  key: mac,
                                                  class: "pl-16",
                                                  density: "compact"
                                                }, {
                                                  prepend: _withCtx(() => [
                                                    _createVNode(_component_v_checkbox_btn, {
                                                      modelValue: selectedMacs.value,
                                                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedMacs).value = $event)),
                                                      value: `${eq.ip}-${mac}`,
                                                      color: "green",
                                                      density: "compact",
                                                      "hide-details": ""
                                                    }, null, 8, ["modelValue", "value"])
                                                  ]),
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_list_item_title, { class: "text-caption text-grey" }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode("MAC: " + _toDisplayString(mac), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1024))
                                              }), 128))
                                            ]),
                                            _: 2
                                          }, 1032, ["value"]))
                                        }), 128))
                                      ]),
                                      _: 2
                                    }, 1032, ["value"]))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1032, ["value"]))
                            }), 128))
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_divider),
                        _createVNode(_component_v_list_group, { value: "temperatura_root" }, {
                          activator: _withCtx(({ props }) => [
                            _createVNode(_component_v_list_item, _mergeProps(props, {
                              "prepend-icon": "mdi-robot-excited-outline",
                              title: "IA"
                            }), null, 16)
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item, { class: "py-2" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_switch, {
                                  modelValue: showAllClustering.value,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showAllClustering).value = $event)),
                                  label: "Clustering",
                                  color: "green",
                                  "hide-details": ""
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_divider),
                            _createVNode(_component_v_list_item, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_switch, {
                                  modelValue: allVisibleTemperatura.value,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((allVisibleTemperatura).value = $event)),
                                  label: "Mostrar todo",
                                  "hide-details": "",
                                  color: "green",
                                  onChange: _cache[4] || (_cache[4] = ($event: any) => (toggleAll()))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hierarchy.value, (subtipoData, subtipo) => {
                              return (_openBlock(), _createBlock(_component_v_list_group, {
                                key: 'temp-' + subtipo,
                                value: 'temp-' + subtipo
                              }, {
                                activator: _withCtx(({ props }) => [
                                  _createVNode(_component_v_list_item, _mergeProps(props, { class: "py-2" }), {
                                    prepend: _withCtx(() => [
                                      _createVNode(_component_v_icon, {
                                        icon: "mdi-transit-connection-variant",
                                        color: "white",
                                        class: "mr-2"
                                      })
                                    ]),
                                    append: _withCtx(() => [
                                      _createVNode(_component_v_checkbox_btn, {
                                        "model-value": isSubtipoSelected(subtipo as any),
                                        onClick: _withModifiers(($event: any) => (toggleSubtipo(subtipo as any)), ["stop"]),
                                        color: "green",
                                        density: "compact",
                                        "hide-details": ""
                                      }, null, 8, ["model-value", "onClick"])
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list_item_title, { class: "text-subtitle-1 font-weight-medium" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(subtipo), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1040)
                                ]),
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subtipoData, (equipos, tipo) => {
                                    return (_openBlock(), _createBlock(_component_v_list_group, {
                                      key: tipo,
                                      value: tipo
                                    }, {
                                      activator: _withCtx(({ props }) => [
                                        _createVNode(_component_v_list_item, _mergeProps(props, {
                                          "bg-color": "#1e293b",
                                          class: "pl-8"
                                        }), {
                                          prepend: _withCtx(() => [
                                            _createVNode(_component_v_icon, {
                                              icon: "mdi-folder-outline",
                                              size: "small",
                                              class: "mr-n2"
                                            })
                                          ]),
                                          append: _withCtx(() => [
                                            _createVNode(_component_v_checkbox_btn, {
                                              "model-value": isTipoSelected(subtipo as any, tipo as any),
                                              onClick: _withModifiers(($event: any) => (toggleTipo(subtipo as any, tipo as any)), ["stop"]),
                                              color: "green",
                                              density: "compact",
                                              "hide-details": ""
                                            }, null, 8, ["model-value", "onClick"])
                                          ]),
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_list_item_title, { class: "text-body-2" }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(tipo), 1)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1040)
                                      ]),
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(equipos, (equipo) => {
                                          return (_openBlock(), _createBlock(_component_v_list_item, {
                                            key: equipo.name,
                                            class: "pl-16"
                                          }, {
                                            prepend: _withCtx(() => [
                                              _createVNode(_component_v_checkbox_btn, {
                                                modelValue: selectedEquiposTemperatura.value,
                                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((selectedEquiposTemperatura).value = $event)),
                                                value: equipo.name,
                                                color: "green",
                                                density: "compact",
                                                "hide-details": "",
                                                class: "mr-2"
                                              }, null, 8, ["modelValue", "value"])
                                            ]),
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_list_item_title, { class: "text-caption font-weight-bold" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(equipo.name), 1)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1024))
                                        }), 128))
                                      ]),
                                      _: 2
                                    }, 1032, ["value"]))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1032, ["value"]))
                            }), 128))
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_divider)
                      ]),
                      _: 1
                    }, 8, ["opened"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _hoisted_4
    ]),
    (showAllClustering.value)
      ? (_openBlock(), _createBlock(_component_v_row, {
          key: 0,
          class: "ma-0 mt-4",
          justify: _unref(smAndDown) ? 'center' : 'space-between'
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_sheet, {
              color: "transparent",
              width: _unref(smAndDown) ? '100%' : 360
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, {
                  class: "ma-0",
                  justify: _unref(smAndDown) ? 'center' : 'start'
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [
                        _createTextVNode(" mdi-thermometer-lines ")
                      ]),
                      _: 1
                    }),
                    _createElementVNode("span", _hoisted_5, [
                      _createTextVNode(_toDisplayString(_unref(t)("labels.temperature")) + " | ", 1),
                      _createElementVNode("span", null, _toDisplayString(_unref(t)("labels.averageTemperature")), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["justify"])
              ]),
              _: 1
            }, 8, ["width"]),
            _createVNode(rangeComponent, {
              class: _normalizeClass(_unref(smAndDown) ? 'mt-2' : 'mt-0'),
              "principal-color": _unref(COLOR).green,
              "secundary-color": 'rgb(62 97 57)',
              "color-text-princ": 'white',
              "color-text-secun": 'white',
              "principal-text": _unref(t)('labels.ok'),
              "secundary-text": '-40°C a 30°C',
              sheetWidth: _unref(smAndDown) ? 350 : 225
            }, null, 8, ["class", "principal-color", "secundary-color", "principal-text", "sheetWidth"]),
            _createVNode(rangeComponent, {
              class: _normalizeClass(_unref(smAndDown) ? 'mt-2' : 'mt-0'),
              "principal-color": _unref(COLOR).yellow,
              "secundary-color": '#B4A343',
              "color-text-princ": 'black',
              "color-text-secun": 'white',
              "principal-text": _unref(t)('labels.normal'),
              "secundary-text": '31°C a 60°C',
              sheetWidth: _unref(smAndDown) ? 350 : 225
            }, null, 8, ["class", "principal-color", "principal-text", "sheetWidth"]),
            _createVNode(rangeComponent, {
              class: _normalizeClass(_unref(smAndDown) ? 'mt-2' : 'mt-0'),
              "principal-color": _unref(COLOR).orange,
              "secundary-color": '#a87119',
              "color-text-princ": 'white',
              "color-text-secun": 'white',
              "principal-text": _unref(t)('labels.verifying'),
              "secundary-text": '61°C a 70°C',
              sheetWidth: _unref(smAndDown) ? 350 : 225
            }, null, 8, ["class", "principal-color", "principal-text", "sheetWidth"]),
            _createVNode(rangeComponent, {
              class: _normalizeClass(_unref(smAndDown) ? 'mt-2' : 'mt-0'),
              "principal-color": _unref(COLOR).red,
              "secundary-color": '#8F3A36',
              "color-text-princ": 'white',
              "color-text-secun": 'white',
              "principal-text": _unref(t)('labels.alert'),
              "secundary-text": 'Mayor a 70°C',
              sheetWidth: _unref(smAndDown) ? 350 : 225
            }, null, 8, ["class", "principal-color", "principal-text", "sheetWidth"])
          ]),
          _: 1
        }, 8, ["justify"]))
      : _createCommentVNode("", true),
    (hoverData.value.show)
      ? (_openBlock(), _createBlock(_component_v_sheet, {
          key: 1,
          style: _normalizeStyle({ 
    position: 'absolute', 
    left: (hoverData.value.x + 85) + 'px', 
    top: (hoverData.value.y + 15) + 'px', 
    zIndex: 100,
    pointerEvents: 'none' /* Importante: para que el sheet no interfiera con el mousemove */
  }),
          class: "pa-3 rounded-lg elevation-10",
          color: "grey-darken-4",
          theme: "dark",
          width: "230"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, _toDisplayString(hoverData.value.nombre), 1),
            _createElementVNode("div", _hoisted_7, _toDisplayString(hoverData.value.ip), 1),
            _createVNode(_component_v_divider, {
              class: "my-2",
              color: "white"
            }),
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("span", null, _toDisplayString(hoverData.value.temp) + "°C", 1)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("span", null, _toDisplayString(hoverData.value.volt) + "V", 1)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("span", null, _toDisplayString(hoverData.value.noise), 1)
            ])
          ]),
          _: 1
        }, 8, ["style"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})